import { Icon, Tooltip } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { SyntheticEvent } from 'react'
import { useRouteMatch } from 'react-router'

import { GrupoExameRowItem } from './GrupoExameTable'

interface GrupoExameEditActionProps {
  grupoExame: GrupoExameRowItem
}

export function GrupoExameEditAction(props: GrupoExameEditActionProps) {
  const { grupoExame } = props
  const match = useRouteMatch()
  const onClick = (e: SyntheticEvent) => {
    e.stopPropagation()
  }

  return (
    <Tooltip text='Editar'>
      <ButtonLink onClick={onClick} to={`${match.url}/edit/${grupoExame.id}`} size='small' skin='ghost'>
        <Icon icon='penOutline' />
      </ButtonLink>
    </Tooltip>
  )
}
